import React from 'react'
import PropTypes from 'prop-types'
const { numberFormat } = require('app/util/formaters')

export default class BasketLine extends React.PureComponent {
  static get propTypes () {
    return {
      title: PropTypes.any,
      description: PropTypes.any,
      value: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      title: null,
      description: null,
      value: 0
    }
  }

  render () {
    const { title, description, value } = this.props

    return (
      <div className='basket-line price-line'>
        <div className='line-title'>
          {title}
          <span>{description}</span>
        </div>
        <div className='line-body'>{numberFormat(value)}</div>
      </div>
    )
  }
}
